let blocks = {};

$(".stages-item__item").mouseenter(function () {
    let hidden_block = $(this).find('.stages-item__hidden-content');
    let block_number = hidden_block.attr('data-block');
    hidden_block.slideDown(500);

    if (blocks[block_number]) {
        clearTimeout(blocks[block_number]);
        delete blocks[block_number];
    }
});

$(".stages-item__item").mouseleave(function() {
    let hidden_block = $(this).find('.stages-item__hidden-content');
    let block_number = hidden_block.attr('data-block');

    if (!blocks[block_number]) {
        blocks[block_number] = setTimeout(function () {
            hidden_block.slideUp(500);
            delete blocks[block_number];
        }, 3000);
    }
});




// WEBPACK FOOTER //
// ./_src/js/StageBlocks.js